<template>
    <div class="w-100">
        <!-- media manager -->
        <media-manager
            v-if="showMediaManagerBackgroundImage"
            :maxItemSelected="1"
            :maxUploadFiles="1"
            @receiveMedias="addPictures($event)"
            @closeTabs="() => showMediaManagerBackgroundImage = false"
        />

        <!-- component -->
        <label class="font-14 mt-2" for="upload-input">
            Imagem de fundo
        </label>
        
        <div class="d-flex justify-content-start align-items-center">
            <div id="background-image-container" class="position-relative">
                <base-image class="background-image-container--image" :source="activeUrl" />

                <div
                    v-b-tooltip.hover
                    title="Remover"
                    @click="resetImage"
                    :class="[url ? 'd-flex' : 'd-none']"
                    id="remove-image"
                >
                    <button
                        class="btn btn-block btn-primario px-2 py-0"
                    >
                        <i class="fal fa-trash-alt font-14" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
            
            <button 
                v-if="this.url == null"
                @click.prevent="showManager"
                class="upload-button d-flex text-center flex-column justify-content-center align-items-center fs-5 font-16 fw-bold"
            >
                <i class="fal fa-upload w-100"></i>

                <span class="w-100">Enviar arquivo</span>
            </button>
        </div>
    </div>
</template>

<script>
import MediaManager from '../organisms/MediaManager.vue'
import BaseImage from './BaseImage.vue'

export default {
    name: 'SettingFrameBackgroundImage',
    data() {
        return {
            showMediaManagerBackgroundImage: false,
            image: {
                url: null
            }
        }
    },
    props: {
        url: {
            type: String,
        }
    },
    components: {
        BaseImage,
        MediaManager
    },
    methods: {
        showManager() {
            this.showMediaManagerBackgroundImage = true;
        },
        addPictures(picture) {
            this.image.url = picture[0].url

            this.showMediaManagerBackgroundImage = false;

            this.$emit('onChangeBackgroundImage', this.image.url);
        },
        resetImage() {
            this.image.url =  null;

            this.$emit('onChangeBackgroundImage', this.image.url);
        }
    },
    computed: {
        activeUrl() {
            if (this.image.url) { return this.image.url }
        }
    },
    created() {
        this.image.url = this.url
    }
}
</script>

<style scoped>
    .background-image-container--image {
        width: 150px;
        height: 150px;
        object-fit: cover;
        object-position: center;
        border: 2px dashed var(--main-color);
        border-radius: 8px;
    }

    .upload-button {
        margin: 0;
        cursor: pointer;
        font-size: 1.25em;
        width: 150px;
        height: 150px;
        max-height: 150px;
        max-width: 150px;
        display: inline-block;
        border-radius: 8px;
        background: #f0f0f0;
        padding: 0.25em 0.75em;
    }

    #remove-image {
        position: absolute;
        bottom: 8px;
        right: 8px;
        cursor: pointer;
        z-index: 10;
    }
</style>


// WEBPACK FOOTER //
// src/components/atoms/SettingFrameBackgroundImage.vue